/* eslint-disable import/prefer-default-export  */

export const ISSUABLE_INDEX = {
  MERGE_REQUEST: 'merge_request_',
  ISSUE: 'issue_',
};



// WEBPACK FOOTER //
// ./pages/projects/constants.js